// Índice dedicado do bundle público (guests.js): registra apenas os
// controllers usados nas páginas públicas de marketing.
// Ao usar um novo controller em página pública, registre-o aqui.
import { application } from "./application"

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import LandingSignupController from "./landing_signup_controller"
application.register("landing-signup", LandingSignupController)

import LandingTrackingController from "./landing_tracking_controller"
application.register("landing-tracking", LandingTrackingController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)
